// constants/permissions.ts

export enum PermissionEnums {
  ManageCustomModule = "manage_custom_module",
  ManagePipeline = "manage_pipeline",
  ManageMarketingMatrix = "manage_marketing_matrix",
  ManageIntegrations = "manage_integrations",
  ManageGroup = "manage_group",
  ManageUsers = "manage_users",
  LeadListingAddLead = "lead_list:add_lead",
  LeadProfileEditContact = "lead_profile:edit_contact",
  LeadGeneralReAssign = "lead_general:re_assign",
  ManageReports = "manage_reports",
  LeadBulkReAssign = "lead_bulk:re_assign",
  LeadBulkDownload = "lead_bulk:download",
  ManagePermissions = "manage_permissions",
  ManageWorkflows = "manage_workflows",
  ManageRequests = "manage_requests",
}

export enum Role {
  Admin = "ADMIN",
  Executive = "EXECUTIVE",
  Manager = "MANAGER",
}

export const RolePermissions: Record<string, PermissionEnums[]> = {
  [Role.Admin]: [
    PermissionEnums.ManageCustomModule,
    PermissionEnums.ManagePipeline,
    PermissionEnums.ManageMarketingMatrix,
    PermissionEnums.ManageIntegrations,
    PermissionEnums.ManageGroup,
    PermissionEnums.ManageUsers,
    PermissionEnums.LeadGeneralReAssign,
    PermissionEnums.ManageReports,
    PermissionEnums.LeadBulkReAssign,
    PermissionEnums.LeadBulkDownload,
    PermissionEnums.LeadListingAddLead,
    PermissionEnums.LeadProfileEditContact,
    PermissionEnums.ManagePermissions,
    PermissionEnums.ManageWorkflows,
    PermissionEnums.ManageRequests
  ],
  [Role.Executive]: [
    PermissionEnums.ManageCustomModule,
  ],
  [Role.Manager]: [
    PermissionEnums.ManageCustomModule,
    PermissionEnums.LeadGeneralReAssign,
    PermissionEnums.LeadBulkReAssign,
    PermissionEnums.ManageRequests,
  ],
};

// User-friendly display names for permissions
export const PermissionDisplayNames: Record<PermissionEnums, { name: string; description: string; isHidden?: boolean }> = {
  [PermissionEnums.ManageCustomModule]: {
    name: "Manage Custom Modules",
    description: "Create, edit, and manage custom modules and fields"
  },
  [PermissionEnums.ManagePipeline]: {
    name: "Manage Pipeline",
    description: "Configure and manage sales pipeline stages and workflows"
  },
  [PermissionEnums.ManageMarketingMatrix]: {
    name: "Manage Marketing Matrix",
    description: "Access and manage marketing matrix configurations"
  },
  [PermissionEnums.ManageIntegrations]: {
    name: "Manage Integrations",
    description: "Configure and manage third-party integrations and APIs"
  },
  [PermissionEnums.ManageGroup]: {
    name: "Manage Groups",
    description: "Create, edit, and manage user groups and teams"
  },
  [PermissionEnums.ManageUsers]: {
    name: "Manage Users",
    description: "Add, edit, and manage user accounts and permissions"
  },
  [PermissionEnums.LeadListingAddLead]: {
    name: "Add New Leads",
    description: "Create and add new leads to the system"
  },
  [PermissionEnums.LeadProfileEditContact]: {
    name: "Edit Lead Contacts",
    description: "Modify lead contact information and details"
  },
  [PermissionEnums.LeadGeneralReAssign]: {
    name: "Reassign Leads",
    description: "Reassign leads to different users or teams"
  },
  [PermissionEnums.ManageReports]: {
    name: "Manage Reports",
    description: "Generate, view, and manage system reports and analytics"
  },
  [PermissionEnums.LeadBulkReAssign]: {
    name: "Bulk Reassign Leads",
    description: "Reassign multiple leads at once in bulk operations"
  },
  [PermissionEnums.LeadBulkDownload]: {
    name: "Bulk Download Leads",
    description: "Download lead data in bulk for export and analysis"
  },
  [PermissionEnums.ManagePermissions]: {
    name: "",
    description: ""
  },
  [PermissionEnums.ManageWorkflows]: {
    name: "Manage Workflows",
    description: "Create and manage workflows to automate tasks and processes.",
    isHidden: true,
  },
  [PermissionEnums.ManageRequests]: {
    name: "Manage Requests",
    description: "Handle and process user requests and inquiries"
  }
};
